/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { AppState } from 'src/app/services/app-state.service';
import { RallyBaseComponent } from '../rally-base.component';
import { RallyPointService } from 'src/app/services/rally-point.service';

import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import * as appStrings from '@touchplan/strings';
import { switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { AccountCreationStore } from '../../auth/services/account-creation-store.service';
import { LoadingBlockerState } from '../../utility-components/loading-blocker';

@Component({
	selector: 'rally-start',
	templateUrl: './rally-start.component.html',
	styleUrls: ['./rally-start.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RallyStartComponent extends RallyBaseComponent implements OnInit, OnDestroy {
	protected appStrings = appStrings;

	public rallyForm = this.formBuilder.group({
		accessCode: ['', [Validators.required]],
	});

	constructor(
		private formBuilder: UntypedFormBuilder,
		protected accountCreationStore: AccountCreationStore,
		protected appState: AppState,
		private authService: AuthService,
		protected router: Router,
		public rallyPointService: RallyPointService
	) {
		super(router, rallyPointService, accountCreationStore);
	}

	public next() {
		this.accountCreationStore.setLoadingState(LoadingBlockerState.inProgress);

		if (!this.rallyForm.controls.accessCode.value) {
			Logging.warning('an access code must be entered');
			this.accountCreationStore.setLoadingState(LoadingBlockerState.failure);
			return;
		}

		this.accountCreationStore.setAccessCode(this.rallyForm.controls.accessCode.value);

		this.rallyPointService
			.getAccessCode$(this.rallyForm.controls.accessCode.value)
			.pipe(
				take(1),
				tap((codeAccessData) => this.accountCreationStore.setAccessCodeData(codeAccessData)),
				switchMap((codeAccessData) => this.rallyPointService.getAccessCodeRedirectURL$(codeAccessData)),
				takeUntil(this.shutdownSubject)
			)
			.subscribe((result) => {
				if (result?.route) {
					this.accountCreationStore.setLoadingState(LoadingBlockerState.empty);
					this.router.navigate(result.route);
				} else {
					this.accountCreationStore.setLoadingState(LoadingBlockerState.failure);
				}
				if (result.message) {
					Logging.warning(result.message);
				}
			});
	}

	public onCancel() {
		this.appState.user.pipe(take(1)).subscribe((user) => {
			if (!user) {
				this.router.navigate(['login']);
			} else {
				this.router.navigate(['/projects']);
			}
		});
	}

	public logout() {
		this.authService.logout();
	}
}
